export default "__VITE_ASSET__BiqzhkB9__"